export default "__VITE_ASSET__b454d6b3__"